function NotFound() {
  return (
    <div className="flex justify-center mt-56">
      <h2 className="font-bold font-clashDisplay">Page not found</h2>
    </div>
  );
}

export default NotFound;
